import React, { useEffect, useRef } from "react";
import { Link } from "gatsby";
import * as styles from "./home-menu.module.scss";
import { useTranslation } from "react-i18next";
import {
  minDeliveryProductPrice,
  phoneNum,
  phoneNumHref,
} from "../../../shared/data/data.utils";

export const HomeMenu = () => {
  const { t } = useTranslation();
  const linksRef = useRef<HTMLAnchorElement[]>([]);

  const menuItems = [
    {
      name: t("home_menu.items.click_collect"),
      subtitle: t("home_menu.items.click_collect_subtitle"),
      subtitle2: t("home_menu.items.click_collect_subtitle2"),
      button: t("home_menu.items.click_collect_button"),
      to: "/menu#sushi",
      img: "/images/home-page/home_click_collect.webp",
    },
    {
      name: t("home_menu.items.delivery"),
      to: "/delivery",
      subtitle: t("home_menu.items.delivery_subtitle"),
      subtitle2: t("home_menu.items.delivery_subtitle2"),
      button: t("home_menu.items.delivery_button"),
      img: "/images/home-page/home_delivery.webp",
    },
    {
      name: t("home_menu.items.dineIn"),
      to: "/restaurant",
      subtitle: t("home_menu.items.dineIn_subtitle"),
      subtitle2: t("home_menu.items.dineIn_subtitle2"),
      img: "/images/home-page/home_dine_in.webp",
      button: t("home_menu.items.delivery_button"),
    },
  ];

  return (
    <section data-scroll-follow className={styles.menu}>
      <div className={styles.menu__wrapp}>
        <div className={styles.minOrderInfo}>
          <div className={styles.minOrderInfo__text}>
            {t("common.min_order", { amount: minDeliveryProductPrice })}
          </div>
        </div>
        <div className={styles.menu__cards}>
          {menuItems.map((item, i) => (
            <div key={i} className={styles.menu__cardsItem}>
              <div className={styles.menu__cardsLink}>
                <div className={styles.menu__cardsImg}>
                  <img src={item.img} alt={item.name} />
                </div>
                <div className={styles.menu__cardsContent}>
                  <div className={styles.menu__cardsContentHeader}>
                    <div className={styles.menu__cardsName}>{item.name}</div>

                    <div className={styles.menu__cardsButtonsContainerMobile}>
                      {item.to && item.button && (
                        <Link to={item.to} className={styles.menu__cardsButton}>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.16602 10.0003H15.8327M15.8327 10.0003L12.4993 13.3337M15.8327 10.0003L12.4993 6.66699"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </Link>
                      )}
                      {item.showPhoneNumber && (
                        <a
                          href={phoneNumHref}
                          className={styles.menu__cardsButton}
                        >
                          <svg
                            className={styles.menu__cardsButtonPhone}
                            viewBox="0 0 19 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3 1.5H7L9 6.5L6.5 8C7.57096 10.1715 9.32847 11.929 11.5 13L13 10.5L18 12.5V16.5C18 17.0304 17.7893 17.5391 17.4142 17.9142C17.0391 18.2893 16.5304 18.5 16 18.5C12.0993 18.263 8.42015 16.6065 5.65683 13.8432C2.8935 11.0798 1.23705 7.40074 1 3.5C1 2.96957 1.21071 2.46086 1.58579 2.08579C1.96086 1.71071 2.46957 1.5 3 1.5Z"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                          </svg>
                        </a>
                      )}
                    </div>
                  </div>
                  <div className={styles.menu__cardsSubtitleContainer}>
                    <div className={styles.menu__cardsSubtitle}>
                      {item.subtitle}
                    </div>
                    <div className={styles.menu__cardsSubtitle2}>
                      {item.subtitle2}
                    </div>
                  </div>
                  <div className={styles.menu__cardsButtonsContainerDesktop}>
                    {item.to && item.button && (
                      <Link to={item.to} className={styles.menu__cardsButton}>
                        {item.button}
                      </Link>
                    )}
                    {item.showPhoneNumber && (
                      <a
                        href={phoneNumHref}
                        className={styles.menu__cardsButton}
                      >
                        <svg
                          viewBox="0 0 19 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3 1.5H7L9 6.5L6.5 8C7.57096 10.1715 9.32847 11.929 11.5 13L13 10.5L18 12.5V16.5C18 17.0304 17.7893 17.5391 17.4142 17.9142C17.0391 18.2893 16.5304 18.5 16 18.5C12.0993 18.263 8.42015 16.6065 5.65683 13.8432C2.8935 11.0798 1.23705 7.40074 1 3.5C1 2.96957 1.21071 2.46086 1.58579 2.08579C1.96086 1.71071 2.46957 1.5 3 1.5Z"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <div className={styles.footer__contactsTxt}>
                          {phoneNum}
                        </div>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
